import React, { FC } from 'react';
import 'antd/dist/antd.min.css';
import './loader.scss';
import { Player } from '@lottiefiles/react-lottie-player';
import loaderAnimation from '../../../assets/lottie/loader.json';

type LoaderType = 'full-screen' | 'component';
type LoaderProps = {
    type: LoaderType
}

const Loader: FC<LoaderProps> = ({ type }) => {
    const classname = `${type}-loader`;
    return <div data-testid={classname} className={classname}>
        <Player className="loader-animation" autoplay={true} loop={true} src={loaderAnimation} />
    </div>;
};
export default Loader;
